<template>
  <div :class="['control-panel', 'has-border-bottom', scenario === 'external-share' && 'external-share-control-panel']">
    <div class="logo-section">
      <a :href="imageUrl">
        <img :src="logoUrl" :alt="product_name">
      </a>
    </div>
    <div class="control-panel-content">
      <div v-if="!user_info.id" class="lang-selector">
        <span class="lang" @click="triggerLangPopup">{{langMap[$i18n.locale]}}</span>
        <i :class="['iconfont', `icon-arrow-${showLangPopup ? 'up1' : 'down1'}`]"></i>
      </div>
      <div class="login-section ellipsis">
        <span v-if="user_info.id" class="user-name" @click="triggerLogoutPopup">{{user_info.name}}</span>
        <template v-else>
          <a :href="loginUrl + '?redirect=' + encodeURIComponent(pathname)" class="login">{{$t('base.login')}}</a><a v-if="!is_custom_product" target="_blank" :href="`${registerUrl}?m_r=share`" class="register">{{$t('base.register')}}</a>
        </template>
      </div>
    </div>
    <van-popup
      v-model="showLangPopup"
      class="lang-popup"
      :overlay-style="{background: 'transparent'}"
    >
      <ul @click="handleChangeLang">
        <li><a href="javascript:;" data-value="zh-CN">简体中文</a></li>
        <li><a href="javascript:;" data-value="zh-TW">繁體中文</a></li>
        <li><a href="javascript:;" data-value="en">English</a></li>
      </ul>
    </van-popup>
    <van-popup
      v-model="showLogoutPopup"
      class="logout-popup"
      :overlay-style="{background: 'transparent'}"
    >
      <ul>
        <li><a :href="loginUrl">{{$t('base.go', [product_name])}}</a></li>
        <li><a :href="logoutUrl"><span>{{$t('base.logout')}}</span></a></li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import config from '@/config'
import { domain } from '@/utils/common'
import { i18n } from '@/utils/i18n'

export default {
  name: 'NavControlPanel',
  i18n,
  props: {
    scenario: String
  },
  data () {
    return {
      enterprise_info: config.enterprise_info || {},
      user_info: config.user_info || {},
      imageUrl: config.imageUrl,
      product_name: config.product_name,
      product_id: config.product_id,
      is_custom_product: config.is_custom_product,
      langMap: {
        'zh-CN': '简体中文',
        'zh-TW': '繁體中文',
        'en': 'English'
      },
      showLangPopup: false,
      showLogoutPopup: false,
      pathname: document.location.pathname,
      loginUrl: config.loginUrl,
      logoutUrl: config.logoutUrl,
      registerUrl: config.registerUrl
    }
  },
  computed: {
    logoUrl () {
      const {imageUrl, enterprise_info, product_id, resource_id} = config
      if (enterprise_info['use_enterprise_logo'] || enterprise_info['profile_pic_key']) {
        return `${imageUrl}/enterprises/pic_download?enterprise_id=${enterprise_info['id']}&profile_pic_key=${enterprise_info['profile_pic_key']}`
      } else if (enterprise_info['share_link_logo_pic_key'] && product_id !== 'trcloud') {
        return `${imageUrl}/enterprises/pic_download?enterprise_id=${enterprise_info['share_link_logo_enterprise_id']}&profile_pic_key=${enterprise_info['share_link_logo_pic_key']}`
      } else {
        return `${imageUrl}/assets/app/mobile/images/${resource_id}/logo.${i18n.locale}.png?t=${new Date().getTime()}`
      }
    }
  },
  methods: {
    triggerLangPopup () {
      this.showLangPopup = !this.showLangPopup
    },
    triggerLogoutPopup () {
      this.showLogoutPopup = !this.showLogoutPopup
    },
    handleChangeLang (e) {
      const targetLang = e.target.getAttribute('data-value')
      this.triggerLangPopup()
      if (targetLang !== i18n.locale) {
        i18n.locale = targetLang
        Cookies.set('lang', targetLang, {domain})
      }
    }
  }
}
</script>
<style lang="postcss">
  .control-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 50px;
    box-sizing: border-box;

    & .control-panel-content {
      display: flex;
      align-items: center;
    }

    & .logo-section {
      flex: 0 0 auto;
      width: 100px;
      height: 100%;
      margin-right: 10px;

      & a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }

      & img {
        display: block;
        margin: 0 auto;
        max-height: 100%;
        max-width: 100%;
      }
    }

    & .lang-selector {
      width: 90px;
      font-size: 12px;
      color: #848484;

      & i {
        display: inline-block;
        font-size: 12px;
        color: #b2b7ca;
        transform: scale(.8)
      }
    }

    & .login-section {
      flex: 1 1 auto;
      text-align: right;

      & .login {
        color: var(---, #006BFF);
        font-size: 14px;
        font-weight: 400;
        margin-right: 20px;
      }
      & .register {
        border-radius: 4px;
        background: var(---, #006BFF);
        padding: 0 16px;
        height: 32px;
        color: #fff;
        line-height: 32px;
        display: inline-block;
        font-size: 14px;
      }
    }

    & .lang-popup,
    & .logout-popup {
      width: 90px;
      top: 40px;
      border-radius: 2px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
      transform: none;

      & a {
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        line-height: 30px;
        font-size: 12px;
        color: #38393a;
        text-align: center;
      }
    }

    & .lang-popup {
      left: 110px;
    }

    & .logout-popup {
      left: auto;
      right: 10px;
    }

    &.external-share-control-panel {
      height: 50px;
    }
  }
</style>
